import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { renderReactApp } from '../util/react';
import AppWrapper from '../common/components/AppWrapper';
import CourseApp from './components/CourseApp';

renderReactApp(
  <AppWrapper>
    <Router basename="/course">
      <CourseApp />
    </Router>
  </AppWrapper>,
);
